import { render, staticRenderFns } from "./all-admin.vue?vue&type=template&id=6c5ae4c4&scoped=true&"
import script from "./all-admin.vue?vue&type=script&lang=js&"
export * from "./all-admin.vue?vue&type=script&lang=js&"
import style0 from "./all-admin.vue?vue&type=style&index=0&id=6c5ae4c4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c5ae4c4",
  null
  
)

export default component.exports